<template>
  <div class="illustDetail">
    <router-link to="/illust" class="returnButton" id="return"><span>×</span></router-link>
    <router-link :to="previousLink" class="switchButton" id="previous"><span>&lt;</span></router-link>
    <div class="mainContent">
      <div class="half-split imageArea">
        <img :src="imageURL">
      </div>
      <div class="half-split information">
        <h3 class="title" v-html="title"></h3>
        <h4 class="creator">{{creator}}</h4>
        <p class="message" v-html="message"></p>
        <TwitterButton v-bind:title="title" :key="title"></TwitterButton>
      </div>
    </div>
    <router-link :to="nextLink" class="switchButton" id="next"><span>&gt;</span></router-link>
    
  </div>
</template>

<script>
import TwitterButton from '../common/TwitterButton';

export default {
  name: 'IllustDetailControll',
  components: {
    TwitterButton
  },
  props: ['illustData','previousID','nextID'],
  computed: {
    title: function(){
      if(this.illustData)
        return this.illustData.title;
      else
        return null;
    },
    previousLink: function(){
      return '/illust/' + this.previousID;
    },
    nextLink: function(){
      return '/illust/' + this.nextID;
    },
    imageURL: function(){
      if(this.illustData){

        return this.illustData.imageURL;
      }
      else
        return "#";
    },
    creator: function(){
      if(this.illustData)
        return this.illustData.creator;
      else
        return null;
    },
    message: function(){
      if(this.illustData)
        return this.illustData.message.replace(/\n/g,'<br>');
      else
        return null;
    }
  }
}
</script>

<style scoped>
.illustDetail{
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,0.8);
  position: absolute;
  display: relative;
  top:0;
  left:0;
}

.switchButton{
  display: none;
}

.returnButton{
  display: block;
  position: relative;
  right:0;
  width: 50px;
  height: 50px;
  margin:0;
  margin-left:calc(100% - 50px);
  padding:0;
  color: white;
  vertical-align: middle;
  z-index:1000;
}

.returnButton > span{
   display: inline-block;
   position: absolute;
   top: 50%;
   left: 50%;
   margin: 0;
   margin-right: -50%;
   transform: translate(-50%,-50%);
   color: white;
   font-size:2.5em;
}

.mainContent{
  width: 100%;
  height: calc(100% - 50px);
  display: inline-block;
  overflow-y: auto;
  margin: 0;
}

.imageArea{
  width: 100%;
  height: 70%;
  padding: auto;
  display: inline-block;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.imageArea img{
  display: inline-block;
  max-height: 95%;
  max-width: 95%;
}

.information{
  text-align:center;
  margin-bottom: 65px;
}

.information h3{
  font-size: 1.5em;
  color:white;
  margin: 15px;
}

.information p{
  display: inline-block;
  width: 90%;
  /*max-height: 400px;*/
  overflow-y: auto;
  font-size: 1em;
  color:white;
  text-align: center;
}

.information h4{
  font-size: 1.25em;
  color:white;
}
@media screen and (min-width: 600px){

  .returnButton{
    width: 70px;
    height: 70px;
    margin-left:calc(100% - 70px);
  }


  .mainContent{
    height: calc(100% - 70px);
  }

    .information p{
    font-size: 1.5em;
  }

  .information h3{
    font-size: 2.5em;
  }

  .information h4{
    font-size: 2.0em;
  }
}

@media screen and (min-width: 1280px){
  .illustDetail{
    display: flex;
  }

  .switchButton{
    display: inline-block;
    position: relative;
    width: 80px;
    height: 100%;
    margin:0;
    padding:0;
    background-color: rgba(0,0,0,0.7);
  
    vertical-align: middle;
    line-height: 100%;
  }

  .switchButton > span{
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0;
    margin-right: -50%;
    transform: translate(-50%,-50%);
    color: white;
    font-size:40px;
  }

  .returnButton{
    position: absolute;
    width: 80px;
    height: 80px;
    margin:0;
  }

  .returnButton > span{
    font-size:40px;
  }

  .mainContent{
    width: auto;
    height: 100%;
    flex:1;
    display: inline-flex;
    overflow-y: hidden;
  }

  .half-split{
    margin: 0;
    padding: 0;
    width: 50%;
    height: 100%;
    display: inline-block;
  }

  .imageArea img{
    max-width: 95%;
    max-height: 95%;
  }

  .information h3{
    font-size: 65px;
  }

  .information p{
    font-size: 22px;
    text-align: left;
  }

  .information h4{
    font-size: 30px;
  }
}
</style>
